//#region redux
import { useDispatch, useSelector } from "react-redux";
import { incomingInvoiceForwarded, incomingInvoiceUpdated } from "store/actions/incomingInvoiceActions";
import { AppState } from "store";
//#endregion
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
import { IconDefinitionConstants } from "utils/constants";
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
import { TranslationKeys } from "translations";
import { DialogEnums } from "models/enums";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useIncomingInvoiceService } from "serviceHooks";
import useIncomingInvoicePermissions from "../usePermissions";
//#endregion
import { LocalizationHelperInstance, UtilsHelper } from "utils/helpers";

function useIncomingInvoiceForwardAction(
  id: number | string,
  reloadHandler: (onSuccess?: (invoice: WintSuperkollAPIModel.IncomingInvoice) => void, onError?: () => void) => void
) {
  const incomingInvoiceService = useIncomingInvoiceService();
  const dispatch = useDispatch();

  const loggedInUserId = useSelector((state: AppState) => state.auth.loggedInUser.personId);

  const { getIncomingInvoiceUserPermissions } = useIncomingInvoicePermissions();

  const onForwardUserSelect = (item: SelectionItem | SelectionItem[]) => {
    const selectedItem = item as SelectionItem;
    return incomingInvoiceService.sendToPerson(id as number, selectedItem.id as number, "");
  };

  const getForwardUserSuggestions = () => {
    return UtilsHelper.convertToResultItem(incomingInvoiceService.getSuggestedIncomingInvoicePersons(true));
  };

  const searchForwardUsers = (searchText: string) => {
    return UtilsHelper.convertToResultItem(incomingInvoiceService.getIncomingInvoicePersons(searchText, true));
  };

  const onForwardSuccess = () => {
    reloadHandler((i) => {
      if (i.certifyPersonId === loggedInUserId) {
        dispatch(incomingInvoiceUpdated(i, loggedInUserId, getIncomingInvoiceUserPermissions()));
      } else {
        dispatch(incomingInvoiceForwarded(i.id));
      }
    });
  };

  const forwardAction: MoreActionMenuItem = {
    description: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Forward),
    icon: IconDefinitionConstants.WForward,
    actionDialog: {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ForwardToColleague),
      subTitle: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ForwardToWhom),
      titleIcon: IconDefinitionConstants.WForward,
      dialogType: DialogEnums.DialogType.Selection,
      children: {
        getSuggestions: getForwardUserSuggestions,
        search: searchForwardUsers,
        handleSubmit: onForwardUserSelect,
        submitSuccessMessage: LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.IncomingInvoice.ForwardSuccessMessage
        ),
      },
      maxWidth: "sm",
    },
    onActionSuccess: onForwardSuccess,
  };

  return forwardAction;
}

export default useIncomingInvoiceForwardAction;
